class ProductScorecards extends HTMLElement {
  constructor() {
    super();

    this.featuredHandle = this.getAttribute('data-featured');
    this.showAll = this.hasAttribute('show-all');
  }

  connectedCallback() {
    this.productData = getProductData((arg) => {
      this.productData = arg;
      this.loadProductDataAndRender();
    });
  }

  renderProductInfo(product, i) {
    const { node } = product;
    const {
      title,
      featuredImage,
      bande_ph,
      note_finale,
      composition_de_la_barriere_anti_fuites,
      certification_et_labels,
      lieu_de_fabrication,
      blanchiment,
      composition_du_voile_de_contact,
      composition_du_voile_externe,
      prix_unitaire_de_la_couche,
      composition_de_l_absorbant,
      classement_absorption,
      composition_de_l_encre,
      rapport_toxicologique,
      product_url,
      company
    } = node;

    const productCard = document.createElement('div');
    productCard.classList.add('product-card', 'grid', 'grid--2-col-desktop', 'grid--1-col-tablet-down');

    const image = document.createElement('img');
    image.src = featuredImage ? featuredImage.originalSrc : '';
    image.alt = title;
    const imgWrapper = document.createElement('div');
    imgWrapper.classList.add('grid__item', 'product-card__img');
    imgWrapper.appendChild(image);
    productCard.appendChild(imgWrapper);

    const textWrapper = document.createElement('div');
    textWrapper.classList.add('grid__item', 'product-card__text');

    const nutriScoreDiv = document.createElement('div');
    nutriScoreDiv.classList.add('nutriscore');

    const grades = ['A', 'B', 'C', 'D', 'E'];
    grades.forEach(grade => {
      const nutriScoreSpan = document.createElement('span');
      nutriScoreSpan.classList.add('nutriscore-letter', grade);
      nutriScoreSpan.textContent = grade;

      if (this.calculateNutriScore(note_finale) === grade) {
        nutriScoreSpan.classList.add('highlight');
        productCard.classList.add(`product-grade__${grade}`);
      }


      nutriScoreDiv.appendChild(nutriScoreSpan);
    });

    if (this.showAll) {
      let index = parseInt(i) + 1;
      const indexDiv = document.createElement('h2');
      indexDiv.classList.add('product-card__index');
      indexDiv.innerText = index;
      productCard.appendChild(indexDiv);
    }


    const titleElement = document.createElement('div');
    titleElement.classList.add('h2', 'product-card__title');
    titleElement.textContent = `${title} | ${note_finale ? note_finale[0]?.value+'/100' : 'N/A'}`;
    titleElement.append(nutriScoreDiv);
    textWrapper.appendChild(titleElement);

    const propertyList = [
      { key: 'Lieu de fabrication', value: lieu_de_fabrication?.[0]?.value ?? 'N/A' },
      { key: 'Prix moyen unitaire de la couche', value: prix_unitaire_de_la_couche?.[0]?.value ?? 'N/A' },
      { key: 'Classement absorption', value: classement_absorption?.[0]?.value ?? 'N/A' },
      { key: 'Rapport toxicologique', value: rapport_toxicologique?.[0]?.value ?? 'N/A' },
      { key: 'Composition du voile de contact', value: composition_du_voile_de_contact?.[0]?.value ?? 'N/A' },
      { key: 'Composition du voile externe', value: composition_du_voile_externe?.[0]?.value ?? 'N/A' },
      { key: 'Composition de la barrière anti-fuites', value: composition_de_la_barriere_anti_fuites?.[0]?.value ?? 'N/A' },
      { key: 'Composition de l\'absorbant', value: composition_de_l_absorbant?.[0]?.value ?? 'N/A' },
      { key: 'Composition de l\'encre', value: composition_de_l_encre?.[0]?.value ?? 'N/A' },
      { key: 'Bande Ph', value: bande_ph?.[0]?.value ?? 'N/A' },
      { key: 'Blanchiment', value: blanchiment?.[0]?.value ?? 'N/A' },
      { key: 'Certification et labels', value: certification_et_labels?.[0]?.value.replace(/[\[\]"]/g, '') ?? 'N/A' },
      { key: 'Entreprise', value: company?.[0]?.value ?? 'N/A' },
    ];



    propertyList.forEach(({ key, value }) => {
      const propertyElement = document.createElement('div');
      propertyElement.classList.add('product-card__description');
      propertyElement.innerHTML = `<b>${key}</b>: ${value}`;
      textWrapper.appendChild(propertyElement);
    });


    if ((this.featuredHandle && product_url && product_url[0].value && node.handle !== this.featuredHandle) || this.showAll) {
      const div = document.createElement('div');
      div.classList = 'button--wrapper';
      const link = document.createElement('a');
      link.href = product_url[0].value;
      link.classList = 'button product-card__button';
      link.innerHTML = "ACHETER ICI";
      div.appendChild(link);
      textWrapper.appendChild(div);
    }

    productCard.appendChild(textWrapper);


    if (node.handle === this.featuredHandle) {
      this.insertBefore(productCard, this.firstChild);
    } else {
      this.appendChild(productCard);
    }
  }



  calculateNutriScore(note_finale) {
    if (!note_finale.length) return;
    const noteValue = parseFloat(note_finale[0]?.value);
    if (noteValue >= 90) {
      return 'A';
    } else if (noteValue >= 80) {
      return 'B';
    } else  if (noteValue >= 70) {
      return 'C';
    } else  if (noteValue >= 60) {
      return 'D';
    } else return 'E'
  }

  sortProductByScore() {
    return this.productData.products.edges.sort((a, b) => {
      const noteA = a.node.note_finale ? parseFloat(a.node.note_finale[0]?.value) : -1;
      const noteB = b.node.note_finale ? parseFloat(b.node.note_finale[0]?.value) : -1;
      return noteB - noteA
    })
  }

  loadProductDataAndRender() {
    let featuredHandle = null;
    if (this.featuredHandle) {
      const featuredIndex = this.productData.products.edges.findIndex(edge => edge.node.handle === this.featuredHandle);
      if (featuredIndex !== -1) {
        featuredHandle = this.productData.products.edges.splice(featuredIndex, 1)[0];
      }
    }

    const sortedProducts = this.sortProductByScore();

    if (featuredHandle) this.renderProductInfo(featuredHandle);
    if (!this.showAll) {
      if (this.featuredHandle == 'la-marque-en-moins') return;
      const titleElement = document.createElement('h2');
      titleElement.textContent = 'Nos Recommandations';
      titleElement.className = 'product-card__recommandations';
      this.appendChild(titleElement);
      const topFiveRecommendations = sortedProducts.slice(0, 5);
      topFiveRecommendations.forEach(this.renderProductInfo.bind(this));
    } else {
      sortedProducts.forEach((el, i) => this.renderProductInfo(el, i));
    }
  }
}

customElements.define('product-scorecards', ProductScorecards);
